import React from "react";
import { useNavigate } from "react-router-dom";
import "./RooftopSolar.css";
import heroBg from "../../assets/RooftopSolarsection1-1.png";
import rooftopImg from "../../assets/suryaghar.png";
import fin1 from "../../assets/RooftopSolarsection5-1.png";
import fin2 from "../../assets/RooftopSolarsection5-2.png";
import fin3 from "../../assets/RooftopSolarsection5-3.png";
import fin4 from "../../assets/RooftopSolarsection5-4.png";
// Change this line at the top of RooftopSolar.jsx
import solarPanelImg from "../../assets/RooftopSolarsection3.png";
import rtBenefit1 from "../../assets/rooftopbenefits-1.png";
import rtBenefit2 from "../../assets/rooftopbenefits-2.png";
import rtBenefit3 from "../../assets/rooftopbenefits-3.png";
import rtBenefit4 from "../../assets/rooftopbenefits-4.png";
import rtBenefit5 from "../../assets/rooftopbenefits-5.png";

import { useRef, useEffect,useState } from "react";
import pms1step1 from "../../assets/pms1step1.png";
import pms1step2 from "../../assets/pms1step2.png";
import pms1step3 from "../../assets/pms1step3.png";
import pms1step4 from "../../assets/pms1step4.png";
import pms1step5 from "../../assets/pms1step5.png";
import pms2step1 from "../../assets/pms2step1.png";
import pms2step2 from "../../assets/pms2step2.png";
import pms2step3 from "../../assets/pms2step3.png";
import pms2step4 from "../../assets/pms2step4.png";
import pms2step5 from "../../assets/pms2step5.png";
import pms3step1 from "../../assets/pms3step1.png";
import pms3step2 from "../../assets/pms3step2.png";
import pms3step3 from "../../assets/pms3step3.png";
import pms3step4 from "../../assets/pms3step4.png";
import pms3step5 from "../../assets/pms3step5.png";
import pms4step1 from "../../assets/pms4step1.png";
import pms4step2 from "../../assets/pms4step2.png";
import pms4step3 from "../../assets/pms4step3.png";
import pms4step4 from "../../assets/pms4step4.png";
import pms5step1 from "../../assets/pms5step1.png";
import pms5step2 from "../../assets/pms5step2.png";
import pms5step3 from "../../assets/pms5step3.png";
import pms5step4 from "../../assets/pms5step4.png";
import pms5step5 from "../../assets/pms5step5.png";
import pms6step1 from "../../assets/pms6step1.png";
import pms6step2 from "../../assets/pms6step2.png";
import pms6step3 from "../../assets/pms6step3.png";
import pms6step4 from "../../assets/pms6step4.png";
import pms6step5 from "../../assets/pms6step5.png";
import pms7step1 from "../../assets/pms7step1.png";
import pms7step2 from "../../assets/pms7step2.png";
import pms7step3 from "../../assets/pms7step3.png";
import pms7step4 from "../../assets/pms7step4.png";
import pms7step5 from "../../assets/pms7step5.png";
import pms7step6 from "../../assets/pms7step6.png";
import pms8step1 from "../../assets/pms8step1.png";
import pms8step2 from "../../assets/pms8step2.png";
import pms8step3 from "../../assets/pms8step3.png";
import pms8step4 from "../../assets/pms8step4.png";
import pms8step5 from "../../assets/pms8step5.png";
import pms9step1 from "../../assets/pms9step1.png";
import pms9step2 from "../../assets/pms9step2.png";
import pms9step3 from "../../assets/pms9step3.png";
import pms9step4 from "../../assets/pms9step4.png";
import pms9step5 from "../../assets/pms9step5.png";
import pms9step6 from "../../assets/pms9step6.png";
import pms10step1 from "../../assets/pms10step1.png";
import pms10step2 from "../../assets/pms10step2.png";
import pms10step3 from "../../assets/pms10step3.png";
import pms10step4 from "../../assets/pms10step4.png";
import pms10step5 from "../../assets/pms10step5.png";
import pms10step6 from "../../assets/pms10step6.png";
import pms11step1 from "../../assets/pms11step1.png";
import pms11step2 from "../../assets/pms11step2.png";
import pms11step3 from "../../assets/pms11step3.png";
import pms11step4 from "../../assets/pms11step4.png";
import pms11step5 from "../../assets/pms11step5.png";
import pms11step6 from "../../assets/pms11step6.png";
import pms12step1 from "../../assets/pms12step1.png";
import pms12step2 from "../../assets/pms12step2.png";
import pms12step3 from "../../assets/pms12step3.png";
import pms12step4 from "../../assets/pms12step4.png";
import pms12step5 from "../../assets/pms12step5.png";
import pms12step6 from "../../assets/pms12step6.png";
// import stage1 from "../../assets/stage1.png";
// import stage2 from "../../assets/design.png";
// import stage3 from "../../assets/validation.png";
// import stage4 from "../../assets/eligibility.png";
// import stage5 from "../../assets/solar.png";
// import stage6 from "../../assets/design.png";
// import stage7 from "../../assets/solar2.png";
// import stage8 from "../../assets/maintainance.png";
// import stage9 from "../../assets/solar.png";
// import stage10 from "../../assets/training.png";
// import stage11 from "../../assets/solar2.png";
// import stage12 from "../../assets/solar3.png";
import whyImg from "../../assets/RooftopSolarsection-7.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import proj1 from "../../assets/CIRsection6-1.png";
import proj2 from "../../assets/CIRsection6-2.png";

// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";
const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };
    window.addEventListener("scroll", check);
  }, []);
  return ref;
};

/* ================================================
   HERO SECTION
   ================================================ */
const RooftopHero = () => {
  const navigate = useNavigate();
  return (
    <section className="rt-hero-wrapper">
      <div className="rt-hero">
        {/* ── Left: background image panel ── */}
        <div
          className="rt-hero-left"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          {/* Blue tint overlay so text stays readable */}
          <div className="rt-hero-overlay" />

          <div className="rt-hero-content">
            <h1 className="rt-hero-title">
              India's Largest Residential Rooftop Solar Program
            </h1>
            <p className="rt-hero-desc">
              PM Surya Ghar helps Indian homes install subsidized rooftop solar
              and cut electricity bills significantly, with end-to-end support
              from application to grid connection
            </p>
            <button className="rt-hero-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
          </div>
        </div>

        {/* ── Right: photo ── */}
        <div className="rt-hero-right">
          <img
            src={rooftopImg}
            alt="Residential Rooftop Solar Installation"
            className="rt-hero-img"
          />
        </div>
      </div>
    </section>
  );
};

/* ================================================
   ROOFTOP SOLAR PAGE
   ================================================ */
// UPDATE your existing export to include it
const RooftopSolar = () => (
  <>
    <RooftopHero />
    <RooftopOverview />
    <RooftopBenefits />
    <RooftopSubsidy />
    <RooftopFinancial />
    <HowItWorks />
    <RooftopWhyChooseUs />
    <RooftopFeaturedProjects />
    {/* <RooftopTestimonials />      */}
  </>
);

// ADD THIS COMPONENT before the RooftopSolar export
const RooftopOverview = () => {
  const sectionRef = useRef(null);
  const wordRefs = useRef([]);

  const darkText =
    "PM Surya Ghar enables households to install 1 kW–3 kW on-grid rooftop solar systems with direct benefit transfer (DBT) subsidies through the National Portal. ";
  const lightText =
    "The goal is clear: Make clean solar power accessible, affordable, and dependable for every Indian home";

  const allWords = [
    ...darkText.split(" ").map((w) => ({ word: w, type: "dark" })),
    ...lightText.split(" ").map((w) => ({ word: w, type: "light" })),
  ];

  useEffect(() => {
    const onScroll = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const windowH = window.innerHeight;

      // progress: 0 when section top hits bottom of viewport, 1 when section bottom hits top
      const progress = Math.min(
        Math.max((windowH - rect.top) / (windowH + rect.height), 0),
        1,
      );

      const totalWords = wordRefs.current.length;
      const revealCount = Math.floor(progress * totalWords * 1.6); // slightly ahead of scroll

      wordRefs.current.forEach((el, i) => {
        if (!el) return;
        el.style.color = i < revealCount ? "#111111" : "#c0c0c0";
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="rt-overview" ref={sectionRef}>
      <div className="rt-overview-content">
        <p className="rt-overview-tag">
          <span className="rt-overview-dot" />
          OVERVIEW
        </p>
        <p className="rt-overview-text">
          {allWords.map((item, i) => (
            <span
              key={i}
              ref={(el) => (wordRefs.current[i] = el)}
              style={{ color: "#c0c0c0", transition: "color 0.3s ease" }}
            >
              {item.word}
              {i < allWords.length - 1 ? " " : ""}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — BENEFITS
   ================================================ */
const rtBenefitItems = [
  {
    title: "Massive reduction in electricity bills",
    desc: "Generate your own power and reduce monthly bills by 70–90%.",
    img: rtBenefit1,
  },
  {
    title: "Direct subsidy credited to customer's bank account",
    desc: "Transparent DBT model through the National Solar Portal.",
    img: rtBenefit2,
  },
  {
    title: "No hidden charges",
    desc: "Subsidy, installation standards, and warranty policies are government-defined.",
    img: rtBenefit3,
  },
  {
    title: "Smart, on-grid and net-metering enabled",
    desc: "Surplus energy goes back to the grid, reducing bills further.",
    img: rtBenefit4,
  },
  {
    title: "Increase in property value",
    desc: "Solar-enabled homes have higher market value and lower operational costs.",
    img: rtBenefit5,
  },
];

const RooftopBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          rtBenefitItems.length - 1,
          Math.floor(p * rtBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="rt-benefits-outer"
      ref={outerRef}
      style={{ height: `${rtBenefitItems.length * 110}vh` }}
    >
      <section className="rt-benefits-sticky">
        <div className="rt-benefits">
          {/* ── Centered header ── */}
          <div className="rt-benefits-header">
            <p className="rt-benefits-tag">
              <span className="rt-benefits-dot" />
              BENEFITS
            </p>
            <h2 className="rt-benefits-title">
              Lower Bills. Higher Value. Zero Hassle.
            </h2>
          </div>

          {/* ── Body: list left + image right ── */}
          <div className="rt-benefits-body">
            {/* Left benefit items */}
            <div className="rt-benefits-list">
              {rtBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`rt-benefit-item ${
                      i === activeIndex ? "rt-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="rt-benefit-bar" />}

                    <div className="rt-benefit-text">
                      <p className="rt-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="rt-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="rt-benefit-mobile-img-wrap">
                    <div className="rt-benefit-mobile-img-bg" />
                    <img
                      src={item.img}
                      alt={item.title}
                      className="rt-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < rtBenefitItems.length - 1 && (
                    <hr className="rt-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            {/* Right image with blue offset block */}
            <div className="rt-benefits-img-wrap">
              <div className="rt-benefits-img-bg" />
              <img
                src={rtBenefitItems[activeIndex].img}
                alt="Solar Panel"
                className="rt-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
const RooftopSubsidy = () => {
  const cards = [
    {
      load: "ESTIMATED LOAD",
      system: "1 kW System",
      prefix: "Up to ",
      amount: "₹30,000",
      suffix: "\nSubsidy",
    },
    {
      load: "ESTIMATED LOAD",
      system: "2 kW System",
      prefix: "Up to ",
      amount: "₹60,000",
      suffix: "\nSubsidy",
    },
    {
      load: "ESTIMATED LOAD",
      system: "3 kW System",
      prefix: "Up to ",
      amount: "₹78,000",
      suffix: "\nSubsidy",
    },
    {
      load: "ESTIMATED LOAD",
      system: "Above 3 kW",
      prefix: "Subsidy Capped at\n",
      amount: "₹78,000",
      suffix: "",
    },
  ];

  return (
    <section className="rt-subsidy">
      {/* Header */}
      <div className="rt-subsidy-header">
        <p className="rt-subsidy-tag">
          <span className="rt-subsidy-dot" />
          SUBSIDY STRUCTURE
        </p>
        <h2 className="rt-subsidy-title">
          Government-Backed, Direct-To-Homeowner Support
        </h2>
      </div>

      {/* Cards */}
      <div className="rt-subsidy-cards">
        {cards.map((c, i) => (
          <div className="rt-subsidy-card" key={i}>
            <div className="rt-subsidy-card-top">
              <p className="rt-subsidy-card-label">{c.load}</p>
              <p className="rt-subsidy-card-system">{c.system}</p>
            </div>
            <div className="rt-subsidy-card-bottom">
              <p className="rt-subsidy-card-amount">
                {c.prefix && (
                  <span className="rt-subsidy-black">{c.prefix}</span>
                )}
                <span className="rt-subsidy-blue">{c.amount}</span>
                {c.suffix && (
                  <span className="rt-subsidy-black">{c.suffix}</span>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer note */}
      <p className="rt-subsidy-note">
        State-wise additional subsidies may apply based on location and DISCOM.
      </p>
    </section>
  );
};

const RooftopFinancial = () => {
  const cards = [
    { icon: fin1, text: "3-5 year payback period" },
    { icon: fin2, text: "20–25 years of free electricity" },
    { icon: fin3, text: "Low maintenance requirements" },
    { icon: fin4, text: "Immediate bill reduction" },
  ];
  return (
    <section className="rt-financial">
      {/* Header */}
      <div className="rt-financial-header">
        <p className="rt-financial-tag">
          <span className="rt-financial-dot" />
          FINANCIAL ADVANTAGES
        </p>
        <div className="rt-financial-title-wrap">
          <h2 className="rt-financial-title">Real Savings. Real Returns.</h2>
          <p className="rt-financial-subtitle">
            A clean, stable investment for every household
          </p>
        </div>
      </div>

      {/* Cards */}
      <div className="rt-financial-cards">
        {cards.map((c, i) => (
          <div className="rt-financial-card" key={i}>
            <div className="rt-financial-icon">
              <img src={c.icon} alt="" width="31" height="32" loading="lazy" />
            </div>
            <p className="rt-financial-card-text">{c.text}</p>
          </div>
        ))}
      </div>

      {/* Footer ticker */}
      <p className="rt-financial-ticker">
        ZERO FUEL COST • 25-YEAR ASSET • HIGH ROI
      </p>
    </section>
  );
};

/* ================================================
   4. HOW IT WORKS SECTION
   ================================================ */
const stages = [
  {
    id: 1,
    title: "Home Survey",
    steps: [
      { title: "Rooftop measurement & usable area mapping", image: pms1step1 },
      { title: "Shadow analysis & sun path simulation", image: pms1step2 },
      { title: "Structural strength & load-bearing check", image: pms1step3 },
      { title: "Existing wiring & safety inspection", image: pms1step4 },
      { title: "Appliance consumption profiling for savings planning", image: pms1step5 },
    ],
  },
  {
    id: 2,
    title: "System Design",
    steps: [
      { title: "3D panel layout for the rooftop", image: pms2step1 },
      { title: "Inverter selection (string/micro/hybrid)", image: pms2step2 },
      { title: "DC/AC wiring plan", image: pms2step3 },
      { title: "Earthing, lightning & safety protection design", image: pms2step4 },
      { title: "Estimation of expected monthly generation", image: pms2step5 },
    ],
  },
  {
    id: 3,
    title: "Cost & Subsidy",
    steps: [
      { title: "Final project quotation", image: pms3step1 },
      { title: "Applicable subsidy under PM Surya Ghar", image: pms3step2 },
      { title: "Calculation of post-subsidy net cost", image: pms3step3 },
      { title: "Estimated monthly savings & payback period", image: pms3step4 },
      { title: "Financing options (if applicable)", image: pms3step5 },
    ],
  },
  {
    id: 4,
    title: "KYC & Documents",
    steps: [
      { title: "Customer KYC verification", image: pms4step1 },
      { title: "Electricity bill, load sanction, property ownership proofs", image: pms4step2 },
      { title: "DISCOM-required documents", image: pms4step3 },
      { title: "Creation of homeowner digital file for portal submission", image: pms4step4 },
    ],
  },
  {
    id: 5,
    title: "Portal Application",
    steps: [
      { title: "National Solar Portal registration", image: pms5step1 },
      { title: "DISCOM mapping & application submission", image: pms5step2 },
      { title: "Approval tracking through TrueTrack™", image: pms5step3 },
      { title: "Automated status updates to homeowner", image: pms5step4 },
      { title: "Expected sanction timelines", image: pms5step5 },
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "DISCOM approval drawings", image: pms6step1 },
      { title: "Module, inverter, mounting structure procurement", image: pms6step2 },
      { title: "Quality testing before dispatch", image: pms6step3 },
      { title: "Delivery schedules tracked digitally", image: pms6step4 },
      { title: "Installation readiness checklist", image: pms6step5 },
    ],
  },
  {
    id: 7,
    title: "Installation Execution",
    steps: [
      { title: "Daily progress logs (photos, videos, tasks completed)", image: pms7step1 },
      { title: "Structural mounting, panel fixing, DC wiring", image: pms7step2 },
      { title: "AC wiring, inverter setup & safety integrations", image: pms7step3 },
      { title: "Quality checkpoints at every stage", image: pms7step4 },
      { title: "Timeline vs progress graph for homeowner", image: pms7step5 },
      { title: "Zero-hassle, fully transparent installation", image: pms7step6 },
    ],
  },
  {
    id: 8,
    title: "Inspection & Metering",
    steps: [
      { title: "DISCOM inspection scheduling & coordination", image: pms8step1 },
      { title: "Net-meter installation process", image: pms8step2 },
      { title: "Testing of all electrical & safety systems", image: pms8step3 },
      { title: "Synchronization with the home grid", image: pms8step4 },
      { title: "Submission of commissioning documents", image: pms8step5 },
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "Real-time solar generation tracking", image: pms9step1 },
      { title: "Daily/Monthly production reports", image: pms9step2 },
      { title: "Inverter health monitoring", image: pms9step3 },
      { title: "Basic alerts for system faults", image: pms9step4 },
      { title: "Easy homeowner-friendly dashboard", image: pms9step5 },
      { title: "Engineering dashboard for technical teams", image: pms9step6 },
    ],
  },
  {
    id: 10,
    title: "Maintenance & Health",
    steps: [
      { title: "Preventive maintenance recommendations", image: pms10step1 },
      { title: "Cleaning reminders & checklists", image: pms10step2 },
      { title: "Fault ticketing system for quick response", image: pms10step3 },
      { title: "Warranty documentation & service logs", image: pms10step4 },
      { title: "Optional AMC integration", image: pms10step5 },
      { title: "Monthly digital system health report", image: pms10step6 },
    ],
  },
  {
    id: 11,
    title: "Billing & Subsidy",
    steps: [
      { title: "Live subsidy processing update from the portal", image: pms11step1 },
      { title: "Expected payout timeline tracking", image: pms11step2 },
      { title: "Monthly electricity bill reduction insights", image: pms11step3 },
      { title: "Energy consumption vs solar generation charts", image: pms11step4 },
      { title: "EMI tracking (if financed)", image: pms11step5 },
      { title: "Savings projection dashboard", image: pms11step6 },
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Monthly & yearly solar performance reports", image: pms12step1 },
      { title: "Warranty & invoice document storage", image: pms12step2 },
      { title: "Audit-ready generation statements", image: pms12step3 },
      { title: "Insurance and compliance reminders", image: pms12step4 },
      { title: "End-of-year savings summary", image: pms12step5 },
      { title: "25-year lifecycle performance tracking", image: pms12step6 },
    ],
  },
];

const RT_N = stages.length;
const RT_RADIUS = 380;
const RT_ANGLE_STEP = 30;
const RT_MINOR_TICKS = 72;

const HowItWorks = () => {
  const sectionRef = useRef(null);
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".rt-hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * RT_N;
      const activeFloat = Math.min(arcFloat, RT_N - 1);
      const activeIndex = Math.round(activeFloat);
      const currentRotation = -(activeFloat * RT_ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }
      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      stages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;
        const dist = activeFloat - i;
        let opacity = 1;
        if (Math.abs(dist) < 0.5) opacity = 0;
        else if (dist > 0.5) opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        else if (dist < -5) opacity = 0;
        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;
        numEl.style.transform = `rotate(${-(i * RT_ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, RT_N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }
      raf = requestAnimationFrame(update);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = stages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -cardsContainerRef.current.offsetWidth : cardsContainerRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="rt-hiw-outer"
      ref={sectionRef}
      style={{ height: `${stages.length * 110}vh` }}
    >
      <div className="rt-hiw-header-wrap">
        <div className="rt-hiw-tag"><span className="rt-hiw-dot"></span>HOW IT WORKS</div>
        <h2 className="rt-hiw-title">
          True 360° Execution Cycle —<br />Residential Rooftop Solar
        </h2>
        <p className="rt-hiw-subtitle">
          A 12-step, fully integrated, digital-first execution model engineered for India's
          largest residential rooftop solar program.
        </p>
      </div>

      <div className="rt-hiw-sticky">
        <div className="rt-hiw-split">
          <div className="rt-hiw-left">
            <div className="rt-hiw-mobile-header">
              <div className="rt-hiw-tag"><span className="rt-hiw-dot"></span>HOW IT WORKS</div>
              <h2 className="rt-hiw-title">True 360° Execution Cycle —<br />Residential Rooftop Solar</h2>
              <p className="rt-hiw-subtitle">A 12-step, fully integrated, digital-first execution model engineered for India's largest residential rooftop solar program.</p>
            </div>

            <div className="rt-hiw-dial-wrapper">
              <div className="rt-hiw-dial-container" ref={dialRef}>
                <div className="rt-hiw-dial-bg"></div>
                <div className="rt-hiw-dial-inner-orange"></div>

                {Array.from({ length: RT_MINOR_TICKS }).map((_, i) => (
                  <div key={`rt-tick-${i}`} className="rt-hiw-dial-tick-min"
                    style={{ transform: `rotate(${i * (360 / RT_MINOR_TICKS)}deg) translate(${RT_RADIUS}px)` }} />
                ))}

                <svg style={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"678px", height:"678px", pointerEvents:"none", zIndex:2 }}>
                  <circle ref={arcRef} cx="339" cy="339" r="333" fill="none" stroke="#F05A28" strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333} strokeDashoffset={2 * Math.PI * 333} strokeLinecap="round" />
                </svg>

                {stages.map((stage, i) => {
                  const itemAngle = i * RT_ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;
                  return (
                    <React.Fragment key={stage.id}>
                      <div className={`rt-hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${RT_RADIUS}px)` }} />
                      <div className={`rt-hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{ transform: `rotate(${itemAngle}deg) translate(${RT_RADIUS + 40}px)` }}>
                        <div className="rt-hiw-dial-num" ref={(el) => (numRefs.current[i] = el)} style={{ transform: "rotate(-90deg)" }}>
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="rt-hiw-dial-inner">
                <img src={trueRenewablesLogo} alt="True Renewables" className="rt-hiw-center-logo" ref={logoRef} loading="lazy" />
                <div className="rt-hiw-dial-pointer"></div>
              </div>

              <div className="rt-hiw-active-overlay">
                <div className="rt-hiw-inner-faint-line"></div>
                <div className="rt-hiw-active-thick-line"></div>
                <div className="rt-hiw-active-dot"></div>
                <div className="rt-hiw-active-text-block">
                  <span className="rt-hiw-active-num">{numStr}</span>
                  <span className="rt-hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="rt-hiw-mobile-info">
              <div className="rt-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="rt-hiw-mobile-title">{currentStage.title}</h3>
              <p className="rt-hiw-mobile-desc">{currentStage.steps.map((s) => s.title).join(", ")}</p>
              <button className="rt-hiw-mobile-view-btn" onClick={() => setIsMobilePopupOpen(true)}>VIEW DETAILS ↗</button>
            </div>
          </div>

          <div className={`rt-hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div className="rt-hiw-popup-bg" onClick={() => setIsMobilePopupOpen(false)}></div>
            <div className="rt-hiw-popup-inner">
              <button className="rt-hiw-popup-close" onClick={() => setIsMobilePopupOpen(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="rt-hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="rt-hiw-right-title">{currentStage.title}</h2>

              <div className="rt-hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="rt-hiw-step-card">
                    <div className="rt-hiw-step-img-wrap">
                      <img src={step.image} alt={step.title} className="rt-hiw-step-img" loading="lazy" />
                    </div>
                    <div className="rt-hiw-step-text">
                      <p className="rt-hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="rt-hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="rt-hiw-step-bullets">
                          {step.bullets.map((b, i) => <li key={i} className="rt-hiw-step-bullet">{b}</li>)}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="rt-hiw-nav-arrows">
                <button type="button" className="rt-hiw-nav-arrow" onClick={() => scrollCards("left")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                </button>
                <button type="button" className="rt-hiw-nav-arrow" onClick={() => scrollCards("right")}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </button>
              </div>

              <div className="rt-hiw-popup-mobile-info">
                <div className="rt-hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="rt-hiw-mobile-title">{currentStage.title}</h3>
                <p className="rt-hiw-mobile-desc">{currentStage.steps.map((s) => s.title).join(", ")}</p>
                <button className="rt-hiw-mobile-view-btn popup-btn" onClick={() => setIsMobilePopupOpen(false)}>VIEW DETAILS ↗</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   SECTION 7 — WHY CHOOSE US
   ================================================ */
const RooftopWhyChooseUs = () => {
  const leftCards = [
    {
      num: "01",
      text: "MNRE-registered installer with strict compliance standards",
    },
    { num: "02", text: "Transparent pricing with no hidden costs" },
    { num: "03", text: "End-to-end support—survey to subsidy payout" },
  ];
  const rightCards = [
    {
      num: "04",
      text: "Trained engineers, best-quality materials, and safety-first execution",
    },
    { num: "05", text: "Integrated digital ecosystem for full transparency" },
    { num: "06", text: "Fast turnaround time with structured workflows" },
  ];

  return (
    <section className="rt-why">
      {/* Header */}
      <div className="rt-why-header">
        <p className="rt-why-tag">
          <span className="rt-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="rt-why-title">
          Power Your Home.
          <br className="rt-why-title-br" />
          Slash Your Bills.
        </h2>
      </div>

      {/* Body */}
      <div className="rt-why-body">
        {/* Left cards */}
        <div className="rt-why-col">
          {leftCards.map((c) => (
            <div className="rt-why-card" key={c.num}>
              <p className="rt-why-num">{c.num}</p>
              <p className="rt-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        {/* Center image */}
        <div className="rt-why-img-wrap">
          <img src={whyImg} alt="Why Choose Us" className="rt-why-img" loading="lazy" />
        </div>

        {/* Right cards */}
        <div className="rt-why-col">
          {rightCards.map((c) => (
            <div className="rt-why-card" key={c.num}>
              <p className="rt-why-num">{c.num}</p>
              <p className="rt-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 8 — FEATURED PROJECTS
   ================================================ */
const RooftopFeaturedProjects = () => {
  const projects = [
    {
      img: proj1,
      title: "Residential Society Rooftop Solar",
      desc: "Clean power for common areas, lowering society electricity costs significantly.",
      tags: ["BENGALURU", "25 kW", "HOUSING SOCIEYT"],
    },
    {
      img: proj2,
      title: "Small Home Rooftop Solar",
      desc: "Affordable solar installation with fast payback and long-term savings.",
      tags: ["AHMEDABAD", "HOME SOLAR", "2 kW"],
    },
  ];

  return (
    <section className="rooftop-proj-section">
      <div className="rooftop-proj-header">
        <p className="rooftop-proj-tag">
          <span className="rooftop-proj-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="rooftop-proj-title">
          Solar Rooftops Powering Indian Homes
        </h2>
      </div>

      <div className="rooftop-proj-grid">
        {projects.map((p, i) => (
          <div className="rooftop-proj-card" key={i}>
            <div className="rooftop-proj-img-wrap">
              <img src={p.img} alt={p.title} className="rooftop-proj-card-img" loading="lazy" />
            </div>
            <div className="rooftop-proj-card-body">
              <h3 className="rooftop-proj-card-title">{p.title}</h3>
              <p className="rooftop-proj-card-desc">{p.desc}</p>
              <div className="rooftop-proj-tags">
                {p.tags.map((tag, j) => (
                  <span className="rooftop-proj-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

// /* ================================================
//    5. TESTIMONIALS
//    ================================================ */
// const RooftopTestimonials = () => {

// const testimonials = [
//   {
//     id: 1,
//     name: "Anjali Verma",
//     role: "Property Owner, Bengaluru",
//     quote:
//       '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//     photo: Testi1,
//   },
//   {
//     id: 2,
//     name: "Sandeep Reddy",
//     role: "Managing Director, Reddy Commercial Spaces",
//     quote:
//       '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//     photo: Testi2,
//   },
//   {
//     id: 3,
//     name: "Harshvardhan Kulkarni",
//     role: "Director, Altura Industrial Solutions",
//     quote:
//       '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',

//     photo: Testi3,
//   },
// ];

// // ── TESTIMONIAL CARD ──
// const TestimonialCard = ({ item, animClass }) => (
//   <div className={`testi-card ${animClass || ""}`}>
//     <div className="testi-card-content">
//       <div className="testi-person">
//         <div>
//           <p className="testi-name">{item.name}</p>
//           <p className="testi-role">{item.role}</p>
//         </div>
//       </div>
//       <hr className="testi-divider" />
//       <p className="testi-quote">{item.quote}</p>
//     </div>
//     <div className="testi-card-photo">
//       {item.photo ? (
//         <img src={item.photo} alt={item.name} className="testi-photo" />
//       ) : (
//         <div className="testi-photo-placeholder" />
//       )}
//     </div>
//   </div>
// );

// const ChevronLeft = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="15 18 9 12 15 6" />
//   </svg>
// );

// const ChevronRight = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="9 18 15 12 9 6" />
//   </svg>
// );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const headerRef = useReveal();
//   const total = testimonials.length;

//   const prev = () => {
//     setSlideDir("testi-slide-left");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c - 1 + total) % total);
//   };

//   const next = () => {
//     setSlideDir("testi-slide-right");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c + 1) % total);
//   };

//   return (
//     <section className="testi-section">
//       <div className="testi-header reveal-block" ref={headerRef}>
//         <div className="testi-header-left">
//           <p className="testi-tag">
//             <span className="testi-dot"></span> TESTIMONIALS
//           </p>
//           <h2 className="testi-title">
//             Trusted By Clients Across
//             <br />
//             Industries
//           </h2>
//         </div>
//         <div className="testi-header-right">
//           <p className="testi-subtitle">
//             Real experiences from clients who trust us
//             <br />
//             with their solar journey.
//           </p>
//           <div className="testi-arrows testi-arrows-header">
//             <button
//               className="testi-arrow"
//               onClick={prev}
//               aria-label="Previous testimonial"
//             >
//               <ChevronLeft />
//             </button>
//             <button
//               className="testi-arrow"
//               onClick={next}
//               aria-label="Next testimonial"
//             >
//               <ChevronRight />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="testi-cards" key={animKey}>
//         <TestimonialCard
//           item={testimonials[current % total]}
//           animClass={slideDir}
//         />
//         <TestimonialCard
//           item={testimonials[(current + 1) % total]}
//           animClass={`${slideDir} testi-delay`}
//         />
//       </div>

//     </section>
//   );
// };

export default RooftopSolar;
